export const TIME_LISTING = [
  { value: "", label: "Group Report By..." },
  { value: "day", label: "Group by Day" },
  { value: "week", label: "Group by Week" },
  { value: "month", label: "Group by Month" },
  { value: "quarter", label: "Group by Quarter" },
];

export const COMPARISON_LISTING = [
  { value: "", label: "Compare With..." },
  { value: "p-1", label: "Compare with previous Period" },
  { value: "y-1", label: "Compare with Previous Year" },
];

export const MANUFACTURER = [
  {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  {
    reportTitle:'FRM Report',
    reportName:'frm_report'
  },
  {
    reportTitle:'Calls',
    reportName:'call_report'
  },
  {
    reportTitle:'Texts',
    reportName:'text_report'
  },
  {
    reportTitle:'Denials',
    reportName:'denial_report'
  },
  {
    reportTitle:'Xfer',
    reportName:'transfer_report'
  },
  {
    reportTitle:'Login',
    reportName:'login_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  },
  {
    reportTitle:'Analytics Report',
    reportName:'analytics_report'
  },
  {
    reportTitle:'Patient Detail Report',
    reportName:'patient_detail_report'
  },
  {
    reportTitle:' Patient Utilization Report',
    reportName:'patient_utilization_report'
  }
];

export const COLOR_LIST = [
  "#7cb5ec","#434348","#90ed7d","#f7a35c","#8085e9","#f15c80","#e4d354","#2b908f","#f45b5b","#91e8e1"
]
